<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">Atribuir Motorista</h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-tab-group>
    <mat-tab label="Motoristas">
      <div class="pt-4">
        <div class="flex items-end gap-3 mb-3">
          <mat-form-field class="input-tg no-message-new w-2/5" appearance="outline">
            <mat-label>Buscar por CPF (inclusive de outro fornecedor)</mat-label>
            <input matInput [(ngModel)]="cpfSearch" [mask]="'000.000.000-00'" (input)="onCpfInputChange()" />
          </mat-form-field>
          <button class="btn-icon" [disabled]="searchingCpf" (click)="searchByCpf()">
            <mat-icon>search</mat-icon>
          </button>
          @if (cpfResult || cpfNotFound) {
            <button class="btn-icon" matTooltip="Limpar busca" (click)="clearCpfSearch()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>

        @if (cpfResult) {
          <div class="flex justify-between items-center border rounded px-3 py-2 mb-3">
            <div>
              <div class="font-bold">{{ cpfResult.nome }}</div>
              <div class="text-sm text-gray-500">Contato: {{ cpfResult.contato }}</div>
            </div>
            @if (cpfResult.vinculadoAMim) {
              <button
                mat-flat-button class="btn-tg-white"
                [disabled]="assigningId == cpfResult.id"
                (click)="assignExisting(cpfResult.id)"
              >
                @if (assigningId == cpfResult.id) {
                  <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
                } @else {
                  Atribuir
                }
              </button>
            } @else {
              <button
                mat-flat-button class="btn-tg-white"
                [disabled]="assigningId == cpfResult.id"
                (click)="vincularEAtribuir()"
              >
                @if (assigningId == cpfResult.id) {
                  <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
                } @else {
                  Vincular e atribuir
                }
              </button>
            }
          </div>
        }
        @if (cpfNotFound) {
          <p class="text-sm text-gray-500 mb-3">
            Nenhum motorista encontrado com esse CPF. Use a aba "Cadastrar novo" — o CPF já foi preenchido.
          </p>
        }

        @if (loadingList) {
          <mat-spinner diameter="28" class="loading-spinner"></mat-spinner>
        } @else if (myDrivers.length == 0) {
          <p class="text-sm text-gray-500">Você ainda não tem motoristas vinculados.</p>
        } @else {
          <div class="flex flex-col gap-2 max-h-80 overflow-auto">
            @for (driver of myDrivers; track driver.id) {
              <div class="flex justify-between items-center border rounded px-3 py-2">
                <div>
                  <div class="font-bold">{{ driver.nome }}</div>
                  <div class="text-sm text-gray-500">
                    CPF: {{ driver.cpf }} · Categoria: {{ driver.categoria || '-' }}
                  </div>
                  <div class="flex flex-wrap gap-1 mt-1">
                    @if (driver.cnhVencida) {
                      <span class="chip chip-danger">CNH vencida</span>
                    } @else if (driver.cnhProximaDoVencimento) {
                      <span class="chip chip-warning">CNH vence em {{ driver.diasParaVencimentoCnh }} dias</span>
                    }
                    @if (driver.antecedentesVencido) {
                      <span class="chip chip-warning">Antecedentes vencidos</span>
                    } @else if (driver.antecedentesProximoDoVencimento) {
                      <span class="chip chip-warning">Antecedentes vencendo</span>
                    }
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <mat-icon class="btn-icon-outline" fontIcon="edit" matTooltip="Editar" (click)="editDriver(driver)" />
                  <mat-icon class="btn-icon-outline" fontIcon="description" matTooltip="Documentos" (click)="openDocuments(driver)" />
                  <button
                    mat-flat-button class="btn-tg-white"
                    [disabled]="assigningId == driver.id || driverBlocked(driver)"
                    [matTooltip]="driverBlocked(driver) ? 'CNH vencida — atualize a validade antes de atribuir' : ''"
                    (click)="assignExisting(driver.id)"
                  >
                    @if (assigningId == driver.id) {
                      <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
                    } @else {
                      Selecionar
                    }
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Cadastrar novo">
      <div [formGroup]="form" class="pt-4 flex flex-col gap-3">
        <div class="flex gap-4">
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Nome *</mat-label>
            <input matInput formControlName="nome" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:180px" appearance="outline">
            <mat-label>CPF *</mat-label>
            <input matInput formControlName="cpf" [mask]="'000.000.000-00'" />
          </mat-form-field>
        </div>
        <div class="flex gap-4">
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Contato (celular) *</mat-label>
            <input matInput formControlName="contato" />
          </mat-form-field>
        </div>

        <h4>Habilitação</h4>
        <div class="flex gap-4">
          <mat-form-field class="input-tg" style="width:120px" appearance="outline">
            <mat-label>Categoria</mat-label>
            <mat-select formControlName="categoria">
              @for (item of listCategory; track item.id) {
                <mat-option [value]="item.id">{{ item.description }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>N° registro</mat-label>
            <input matInput formControlName="numeroRegistro" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Validade *</mat-label>
            <input matInput [matDatepicker]="validadePicker" (focus)="validadePicker.open()" formControlName="validade" />
            <mat-datepicker-toggle matIconSuffix [for]="validadePicker"></mat-datepicker-toggle>
            <mat-datepicker #validadePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-slide-toggle color="primary" formControlName="antecedentesCriminais">
          Antecedentes criminais verificados
        </mat-slide-toggle>

        @if (form.get('antecedentesCriminais')?.value) {
          <mat-form-field class="input-tg" style="width:200px" appearance="outline">
            <mat-label>Validade antecedentes</mat-label>
            <input matInput [matDatepicker]="antecedentesPicker" (focus)="antecedentesPicker.open()" formControlName="antecedentesValidade" />
            <mat-datepicker-toggle matIconSuffix [for]="antecedentesPicker"></mat-datepicker-toggle>
            <mat-datepicker #antecedentesPicker></mat-datepicker>
          </mat-form-field>
        }

        <h4>Documentos (opcional — CNH, Antecedentes Criminais)</h4>
        <div class="flex items-end gap-3 flex-wrap">
          <mat-form-field class="input-tg flex-1" appearance="outline" style="min-width:160px">
            <mat-label>Descrição</mat-label>
            <input matInput [(ngModel)]="pendingDescricao" [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
          <mat-form-field class="input-tg" appearance="outline" style="width:200px">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="pendingTipoDocId" [ngModelOptions]="{ standalone: true }">
              @for (tipo of tipoDocOptions; track tipo.id) {
                <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <input hidden type="file" (change)="onPendingFileSelected($event)" #pendingFileInput accept=".pdf,.jpg,.jpeg,.png" />
          <mat-form-field class="input-tg" appearance="outline" style="width:200px">
            <mat-label>Arquivo</mat-label>
            <input matInput [value]="pendingFile?.name || ''" readonly (click)="pendingFileInput.click()" />
            <button mat-icon-button matSuffix type="button" (click)="pendingFileInput.click()">
              <mat-icon>upload</mat-icon>
            </button>
          </mat-form-field>
          <button
            mat-flat-button class="btn-tg-white"
            type="button"
            [disabled]="!pendingDescricao || !pendingTipoDocId || !pendingFile"
            (click)="addPendingDocument()"
          >
            Adicionar
          </button>
        </div>
        @if (pendingDocuments.length > 0) {
          <div class="flex flex-col gap-1">
            @for (doc of pendingDocuments; track $index) {
              <div class="flex justify-between items-center border rounded px-2 py-1 text-sm">
                <span>{{ doc.tipoDocDescricao }} — {{ doc.descricao }} ({{ doc.arquivo.name }})</span>
                <mat-icon class="btn-icon-outline" fontIcon="close" matTooltip="Remover" (click)="removePendingDocument($index)" />
              </div>
            }
          </div>
        }

        <div class="flex justify-end mt-2">
          <button
            mat-flat-button class="btn-tg"
            [disabled]="form.invalid || creating"
            (click)="createAndAssign()"
          >
            @if (creating) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Cadastrar e atribuir
            }
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
